
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Affix from '@/components/Affix'
export default {
  name: 'Home',
  data() {
    return {
      isScroll: false,
      scrollTop: 0,
      activeIndex: {value: '/'},
      isShow: {
        isShowCapital: false
      }
    }
  },
  computed: {
    key() {
      return this.$route.path
    }
  },
  methods: {
    // 初始化滚动条
    initScroll() {
      this.$refs.scrollbar.setScrollTop(0)
      this.isShow.isShowCapital = false
      this.scrollTop = 0
    },
    // 根据滚动判断header样式
    handleScroll({scrollTop}) {
      if (scrollTop > 10) {
        if (!this.isScroll) {
          this.isScroll = true
        } else if (scrollTop > 2320 && this.key === '/') {
          this.isShow.isShowCapital = true
        }
      } else if (scrollTop < 10 && this.isScroll) {
        this.isScroll = false
      }
      if (this.$route.name === 'About') {
        this.scrollTop = scrollTop
      }
    }
  },
  provide() {
    return {
      isShow: this.isShow,
      menuActive: this.activeIndex,
      handleMenuActive: (index) => {
        this.activeIndex.value = index
      }
    };
  },
  components: {
    Header,
    Footer,
    Affix
  }
}
